import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import Header from "../../components/shared/header/Header";
import Footer from "../../components/shared/footer/Footer";
import Hero from "../../components/frontpage/hero/Hero";
import PromoboxSecondary from "../../components/frontpage/promobox-secondary/PromoboxSecondary";
import AnalyticsService from "../../services/analytics";
import PopularProducts from "../../components/frontpage/popular-products/PopularProducts";
import WeeklyProducts from "components/frontpage/weekly-products/WeeklyProducts";
import FrontPageModal from "components/shared/FrontPageModal/FrontPageModal";

function Frontpage() {
  const location = useLocation();
  const params = new URLSearchParams(location?.search);
  const enableBarion = Number(params.get("enableBarion"));
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    AnalyticsService.sendPageView(window.location.pathname);
    if (enableBarion === 1) sessionStorage.setItem("enableBarion", "1");
  }, [enableBarion]);

  return (
    <div>
      <Header />
      <Hero />
      <WeeklyProducts />
      <PromoboxSecondary />
      <PopularProducts />
      <Footer />
      {showModal && <FrontPageModal onClose={() => setShowModal(false)} />}
    </div>
  );
}

export default Frontpage;
